import { CORE } from "../commonRepository";
// import { useAccountStore } from '@/core/store/accountStore';
import { useAccount } from '@/core/composables/useAccount';

const setup = async () => {
  // const accountStore = useAccountStore();
  const { userManager } = useAccount();
   const user = await userManager.getUser();
    
  CORE.interceptors.request.use(
    (config) => {
      const token = user.access_token;

      if (token) {
          const bearerAuthorization = `Bearer ${token}`
          config.headers["Authorization"] = bearerAuthorization;
          CORE.defaults.headers.Authorization = bearerAuthorization;
      }

      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
  
  CORE.interceptors.response.use(
      (res) => {
        return res;
      },
      async (err) => {
        const originalConfig = err.config;
  
        if (originalConfig.url !== "/v1/accounts/login" && err.response) {
          if (err.response.status === 401 && !originalConfig._retry) {
            originalConfig._retry = true;
  
            try {
              // const rs = await CORE.post("v1/accounts/token/refresh", {
              //   accessToken: user.access_token,
              //   refreshToken: user.refresh_token,
              // });

              // const { token, refreshToken } = rs.data;
              // accountStore.updateTokes(token, refreshToken);
              return CORE(originalConfig);
            } catch (_error) {
              return Promise.reject(_error);
            }
          }
        }
  
        return Promise.reject(err);
      }
  );
};

export default setup;